import create from "zustand";

export interface iTeamMember {
    image?: any;
    name: string;
    job: string;
    phone?: string;
    email?: string;
    text?: string;
}

export enum Time {
    "7to9" = "7 - 9 Uhr",
    "7to12" = "7 - 12 Uhr",
    "12to16" = "12 - 16 Uhr",
    "16to18" = "16 - 18 Uhr",
}

export interface iForm {
    name: string;
    email: string;
    phone: string;
    time: Time;
    zipcode: string;
    carBrand: string;
    type: string;
    hsn: string;
    tsn: string;
    firstRegistration: string;
    message: string;
    isPrivacyPolicyAccepted: boolean;
}

export interface iProductPackage {
    image: any;
    headline: string;
    text: string;
    price: string;
}

interface iStore {
    activeProduct: null | iProductPackage;
    setActiveProduct: (activeProduct: iProductPackage) => void;
}

const useStore = create<iStore>((set, get) => ({
    activeProduct: null,

    setActiveProduct: (activeProduct) => {
        set({ activeProduct: activeProduct });
    },
}));

export default useStore;
